import { BOOK_EXTERNAL_HTML_REQUEST } from "app/actionTypes";

export const dispatchBookExternalHtmlRequest = () => ({
	type: BOOK_EXTERNAL_HTML_REQUEST,
});
